export default __webpack_public_path__ + "static/media/ssangyong.5ee30154.jpg";